module.exports = __webpack_public_path__ + "static/siteTop-c487ecf5fb485dc729da2dcef7387f8f.jpg";